import { SEARCHQUERY_CHANGE, ADD_SEARCHRESULT } from '../../actions';

const searchReducer = (oldState = {
  searchVm: {
    result: new Map(),
    filterValues: new Set(),
    dateOfYear: '-'
  }
}, action) => {
  const { searchVm } = oldState;
  switch (action.type) {
    case ADD_SEARCHRESULT:
    {
      const { response, key, distance } = action;
      const data = response && response.data();
      const value = { distance, ...data };
      const result = new Map(searchVm.result.set(key, value));
      return {
        ...oldState,
        searchVm: {
          ...searchVm,
          result
        }
      };
    }
    case SEARCHQUERY_CHANGE: {
      const { name, value } = action;
      if (searchVm.filterValues.has(value)) {
        searchVm.filterValues.delete(value);
        return {
          ...oldState,
          searchVm: {
            ...searchVm,
            [name]: new Set(searchVm.filterValues)
          }
        };
      }
      return {
        ...oldState,
        searchVm: {
          ...searchVm,
          [name]: new Set(searchVm.filterValues.add(value))
        }
      };
    }
    default:
      return oldState;
  }
};

export default searchReducer;



// WEBPACK FOOTER //
// ./src/pages/Search/searchReducer.js